import { useEffect, useState } from 'react';
import authInstance from '../services/httpClient';

/**
 * Whether packing should ask for the Loop robo courier's ending — true only on staging/dev
 * with the robo courier on and Loop as the courier (GET /admin/orders/robo-courier).
 * Asked once per page load; any failure means "off", so a real order is never held up
 * by a test prompt.
 */
let cached: Promise<boolean> | null = null;

/** Test hook: forget the cached answer. */
export function resetRoboCourierCache(): void {
  cached = null;
}

export function useRoboCourier(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    cached ??= authInstance
      .get('/admin/orders/robo-courier')
      .then((res) => res.data?.enabled === true)
      .catch(() => false);
    cached.then((on) => { if (alive) setEnabled(on); });
    return () => { alive = false; };
  }, []);
  return enabled;
}
